import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>TEST SITE TEST SITE</p>
        <a
          className="App-link"
          href="https://twitch.tv/warboss741"
          target="_blank"
          rel="noopener noreferrer"
        >
          Twitch Channel
        </a>
      </header>
    </div>
  );
}

export default App;
